import React from 'react'
import PropTypes from 'prop-types'
import RadioButton from './RadioButton.js'

const RadioButtonGroup = props => {
  let radioButtons = props.buttons.map((obj, i) => (
    <div key={i}>
      <RadioButton
        name={obj.name}
        label={obj.label}
        value={obj.value}
        checked={obj.isChecked}
        handler={obj.handler}
      />
    </div>
  ))
  return <div className="form-group">{radioButtons}</div>
}
RadioButtonGroup.propTypes = {
  buttons: PropTypes.array,
}
export default RadioButtonGroup
